/**
 * Client-side only cookie management composable
 * This avoids SSR cookie access that would break Cloudflare caching
 * Cookies are used for cross-domain sharing, but accessed only on client
 */

export function useClientCookie(name, options = {}) {
  const cookieValue = useCookie(name, {
    default: () => null,
    readonly: false,
    ...options,
  });

  const getCookie = () => {
    if (import.meta.server || typeof document === "undefined") return null;
    return cookieValue.value || null;
  };

  const setCookie = (value) => {
    if (import.meta.server || typeof document === "undefined") return;
    cookieValue.value = value;
  };

  const deleteCookie = () => {
    setCookie(null);
  };

  return {
    cookie: readonly(cookieValue),
    getCookie,
    setCookie,
    deleteCookie,
  };
}
